import React from "react";
import { SITE_ORIGIN } from "../data/site";
type SiteLinkProps = {
  path: string;
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
};

/**
 * Links to verified site paths. In-page anchors ("/#id") stay on this page;
 * other paths open the current live page so reviewers can check destinations.
 */
export function SiteLink({
  path,
  className,
  children,
  onClick
}: SiteLinkProps) {
  if (path.startsWith("/#")) {
    return <a href={path.slice(1)} className={className} onClick={onClick} data-id="element-220" data-mp="3ewkcix7tomo">
        {children}
      </a>;
  }
  return <a href={`${SITE_ORIGIN}${path}`} target="_blank" rel="noopener" className={className} onClick={onClick} data-id="element-221" data-mp="3qlp5xyt6b6ik">
      {children}
      <span className="sr-only" data-id="element-222" data-mp="3vk0iihaurv4h"> (opens in a new tab)</span>
    </a>;
}